import React from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';

const PeriodText = observer(() => {
  const { investigationStore } = useStores();
  const { t } = useTranslation();

  const momentFormat = 'ddd, D MMM YYYY, h:mm A';

  let firstPeriod,
    secondPeriod = null;

  if (investigationStore.dates1) {
    const [firstStartDate, firstEndDate] = investigationStore.dates1;
    firstPeriod = moment(firstStartDate).format(momentFormat) + ' - ' + moment(firstEndDate).format(momentFormat);
  }
  if (investigationStore.dates2) {
    const [secondStartDate, secondEndDate] = investigationStore.dates2;
    secondPeriod = moment(secondStartDate).format(momentFormat) + ' - ' + moment(secondEndDate).format(momentFormat);
  }

  return (
    <div className="selectedPeriods">
      {firstPeriod && <span className="firstPeriod">{firstPeriod}</span>}
      {secondPeriod && <span className="vs">{t('VS')}</span>}
      {secondPeriod && <span className="secondPeriod">{secondPeriod}</span>}
    </div>
  );
});

export default PeriodText;
